import IPBoardPart from '../../../../model/product/ip-board/ip-board-part';
import IPBoard from '../../../../model/product/ip-board/ip-board';
import { StringHelper } from '../../../../helpers/string-helper';
import { IPBoardHelper } from '../../../../helpers/ip-board-helper';
import { ClientPendingDetailProduct } from '../../../../model/project/client-pending-detail-product';

export const formatFirstProduct = (
  product: IPBoard | ClientPendingDetailProduct,
  withDisplayExample = true
) => {
  let first = { ...product } as any;
  let boardPart = product.boardPart;
  formatBaseFields(first, boardPart);
  if (product.leftRightBoard) {
    formatLeftRightFields(first, product);
  } else {
    formatRightFields(first, boardPart);
  }

  first.doTitleSidesDiffer = first.title !== first.titleRight;
  first.doPhoneNumberSidesDiffer = first.phoneNumber !== first.phoneNumberRight;

  if (boardPart.customText != null) {
    first.text = boardPart.customText;
    first.textRight = first.text;
  }
  if (boardPart.otherCustomText != null) {
    first.textRight = boardPart.otherCustomText;
  }

  if (boardPart.sticker != null) {
    first.stickerText = boardPart.sticker.text;
  } else if (!StringHelper.isEmpty(boardPart.otherSticker)) {
    first.stickerText = boardPart.otherSticker;
  }

  if (first.otherSideBoardPart != null) {
    if (first.otherSideBoardPart.sticker != null) {
      first.rightStickerText = first.otherSideBoardPart.sticker.text;
    } else if (!StringHelper.isEmpty(first.otherSideBoardPart.otherSticker)) {
      first.rightStickerText = first.otherSideBoardPart.otherSticker;
    }
    if (first.otherSideBoardPart.customText != null) {
      first.textRight = first.otherSideBoardPart.customText;
    }
  }

  if (withDisplayExample) {
    first.ipBoardLeftExample = IPBoardHelper.getLeftDisplayExample(<
      IPBoardPart
    >first.boardPart);
    first.ipBoardRightExample = IPBoardHelper.getRightDisplayExample(<IPBoard>(
      first
    ));
  }
  return first;
};
const formatFields = (
  first: any,
  firstField: string,
  boardPart: IPBoardPart,
  boardPartAdjustmentField: keyof IPBoardPart,
  boardPartSubField: string,
  boardPartOtherField: keyof IPBoardPart
): void => {
  if (boardPart[boardPartAdjustmentField] != null) {
    first[firstField] = boardPart[boardPartAdjustmentField][boardPartSubField];
  } else if (boardPart[boardPartOtherField] != null) {
    first[firstField] = boardPart[boardPartOtherField];
  } else if (boardPart.sign != null) {
    first[firstField] = boardPart.sign[boardPartSubField];
  }
};

const formatBaseFields = (first: any, boardPart: IPBoardPart): void => {
  formatBaseTitle(first, boardPart);
  formatBasePhoneNumber(first, boardPart);
};

const formatBaseTitle = (first: any, boardPart: IPBoardPart): void => {
  formatFields(
    first,
    'title',
    boardPart,
    'titleAdjustment',
    'title',
    'otherTitle'
  );
};

const formatBasePhoneNumber = (first: any, boardPart: IPBoardPart): void => {
  formatFields(
    first,
    'phoneNumber',
    boardPart,
    'phoneNumberAdjustment',
    'phoneNumber',
    'otherPhoneNumber'
  );
};

const formatRightFields = (first: any, boardPart: IPBoardPart): void => {
  formatRightTitle(first, boardPart);
  formatRightPhoneNumber(first, boardPart);
};

const formatRightTitle = (first: any, boardPart: IPBoardPart): void => {
  formatFields(
    first,
    'titleRight',
    boardPart,
    'otherTitleAdjustment',
    'title',
    'otherSideOtherTitle'
  );
};

const formatRightPhoneNumber = (first: any, boardPart: IPBoardPart): void => {
  formatFields(
    first,
    'phoneNumberRight',
    boardPart,
    'otherPhoneNumberAdjustment',
    'phoneNumber',
    'otherSideOtherPhoneNumber'
  );
};

const formatLeftRightFields = (
  first: any,
  ipBoard: IPBoard | ClientPendingDetailProduct
): void => {
  formatLeftRightTitle(first, ipBoard);
  formatLeftRightPhoneNumber(first, ipBoard);
};

const formatLeftRightTitle = (
  first: any,
  ipBoard: IPBoard | ClientPendingDetailProduct
): void => {
  formatFields(
    first,
    'titleRight',
    ipBoard.otherSideBoardPart,
    'otherTitleAdjustment',
    'title',
    'otherTitle'
  );
};
const formatLeftRightPhoneNumber = (
  first: any,
  ipBoard: IPBoard | ClientPendingDetailProduct
): void => {
  formatFields(
    first,
    'phoneNumberRight',
    ipBoard.otherSideBoardPart,
    'phoneNumberAdjustment',
    'phoneNumber',
    'otherPhoneNumber'
  );
};
